import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const RequireAuth = ({ children }) => {
  const isAuthenticated = localStorage.getItem('authToken');

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

// Define PropTypes for children
RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RequireAuth;